import { Tooltip } from '@mui/material';
import i18n from '../../../libs/language';
import AssistantIcon from '@old/assets/svg/main-menu/ai-assistant-icon.svg';
import { useGlobalStore } from '@old/global-store/use-store';

export function AIAssistantIconComponent() {
  // Este llamado se hace para forzar renderizado de este componente y que cambie el idioma del tooltip al vuelo
  void useGlobalStore();

  return (
    <Tooltip title={i18n.t('app.coming_soon')} arrow>
      <span
        style={{
          display: 'inline-block',
          cursor: 'not-allowed',
          lineHeight: 0,
        }}
      >
        <img src={AssistantIcon} alt="assistant" />
      </span>
    </Tooltip>
  );
}
